import FailModal from "../../../../../Components/FailModal";

const DeleteAccountModal = (props) => {
  return (
    <FailModal
      reverse
      show
      title="Confirm Account Deletion"
      description="Are you sure you want to delete your account? All your data, including images and settings, will be permanently removed. This action is irreversible. Please confirm to proceed."
      onCancel={props.Close}
      onRetry={props.RequestDeleteAccount}
      cancelText="Cancel"
      retryText="Delete"
    />
  );
};

export default DeleteAccountModal;
